import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const fadeIn = keyframes({
  '0%': {
    opacity: 0,
    visibility: 'hidden'
  },
  '100%': {
    opacity: 1,
    visibility: 'visible'
  }
});
const fadeOut = keyframes({
  '0%': {
    opacity: 1,
    visibility: 'visible'
  },
  '100%': {
    opacity: 0,
    visibility: 'hidden'
  }
});
export default {
  modal: (isActive: boolean) => ({
    position: 'absolute',
    height: '100vh',
    overflowY: 'hidden',
    top: 0,
    left: 0,
    width: '100vw',
    background: 'neutralWhite',
    p: ['56px 16px 12px 16px', '56px 16px 12px 16px', '72px 24px 12px 24px', '72px 0px 64px 24px', '64px 16px 64px 40px'],
    zIndex: theme.zIndex.modalUp,
    ...(isActive ? {
      animation: `${fadeIn} .28s ease-in-out`,
      opacity: 1,
      visibility: 'visible'
    } : {
      animation: `${fadeOut} .28s ease-in-out`,
      opacity: 0,
      visibility: 'hidden'
    })
  }),
  modalContentImageBox: {
    flex: ['1 1 0', '1 1 0', '1 1 0', 'initial'],
    minHeight: [0, 0, 0, 'auto'],
    width: ['100%', '100%', '100%', '50%'],
    pb: [56, 72, 72, 0],
    height: ['auto', 'auto', 'auto', 'auto'],
    position: 'relative',
    overflow: 'hidden'
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    maxHeight: ['auto', 'auto', 'auto', 'calc(100vh - 128px)'],
    position: 'relative',
    picture: {
      display: 'block',
      width: '100%',
      height: '100%'
    },
    div: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    img: {
      position: 'relative !important',
      width: '100% !important',
      height: '100% !important',
      objectFit: 'cover',
      objectPosition: 'center'
    }
  },
  modalContentProductsBox: {
    p: 0,
    display: 'flex',
    flexShrink: 0,
    width: ['100%', '100%', '100%', '50%'],
    overflowX: 'hidden'
  },
  modalContentFlexContainer: {
    flexWrap: ['no-wrap', 'no-wrap', 'no-wrap', 'wrap'],
    flexDirection: ['column', 'column', 'column', 'row'],
    height: ['calc(100vh - 68px)', 'calc(100vh - 68px)', 'calc(100vh - 84px)', 'auto'],
    minHeight: 0
  },
  modalContentImage: {
    objectPosition: 'center',
    objectFit: 'cover',
    height: ['100%', '100%', '100%', 'calc(100vh - 144px)', 'calc(100vh - 128px)']
  },
  modalContentOverflow: {
    overflowX: 'auto',
    overflowY: 'auto',
    height: ['auto', 'auto', 'auto', 'calc(100vh - 128px)'],
    width: '100%',
    ...reusables.scrollbar('128px', '128px')
  },
  modalContentProductsGrid: {
    overflowY: 'hidden',
    overflowX: ['auto', 'auto', 'auto', 'hidden'],
    display: ['flex', 'flex', 'flex', 'grid'],
    gridTemplateColumns: 'repeat(2, 23.0208333vw )',
    justifyContent: 'flex-start',
    gap: '4px',
    width: ['max-content', 'max-content', 'max-content', 'auto'],
    flexDirection: 'row',
    flexWrap: ['nowrap', 'nowrap', 'nowrap', 'wrap'],
    p: ['0 0 12px', '0 0 12px', '0 0 12px', '0px 0px 0px 12px', '0 24px 0px 48px']
  },
  modalContentProduct: {
    width: ['170px', '170px', '170px', '23.1770833vw', '23.0208333vw'],
    height: '100%'
  },
  modalCloseButton: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    zIndex: theme.zIndex.modalDown
  },
  line: {
    height: '1px',
    bg: theme.rawColors.lightGrey300,
    gridColumn: 'span 2'
  }
};